import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  title: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

const PolicyLayout: React.FC<Props> = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FCFCFC]">
      <div className="py-10 px-4 md:px-20 max-w-4xl mx-auto">
        <button onClick={() => navigate(-1)} className="flex items-center text-gray-500 hover:text-[#DAA520] mb-6 text-sm">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>

        <div className="bg-white rounded-xl shadow-sm p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">{title}</h1>
          {lastUpdated && (
            <p className="text-sm text-gray-400 mb-8">Last updated: {lastUpdated}</p>
          )}
          <div className="prose max-w-none text-gray-600 space-y-6
            [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-gray-800 [&_h2]:mt-8 [&_h2]:mb-3
            [&_h3]:text-lg [&_h3]:font-medium [&_h3]:text-gray-700 [&_h3]:mt-5 [&_h3]:mb-2
            [&_p]:leading-relaxed [&_p]:mb-3
            [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1
            [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-1
            [&_strong]:text-gray-800 [&_strong]:font-semibold
            [&_a]:text-[#DAA520] [&_a]:underline">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyLayout;
